/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import App from "./components/App";
import BootstrapVue from 'bootstrap-vue';
import Loading from 'vue-loading-overlay';
import MilestonesPlugin from "./plugins/milestones";
import Vue from './vue';
import VueHelpers from "./plugins/vue-helpers";
import WsUiKitLibrary from '@milestoneslabs/milestones-ui-kit/src';
import {Engine} from "@milestoneslabs/milestones-core-js";
import axios from "axios";
import './providers/validate';
import {BootstrapVueConfig} from '@milestoneslabs/milestones-ui-kit/src/helpers/bootstrapVueConfig';
import "./event-bus";
import './providers/validate';
import {SelectConfig} from '@milestoneslabs/milestones-ui-kit/src/components/CustomSelect/CustomSelect';
import {SearchCitiesConfig} from '@milestoneslabs/milestones-ui-kit/src/mixins/CityAndStateMixin';
import store from './store';
import VueLazyload from "vue-lazyload";
import Bugsnag from './bugsnag';

require('./bootstrap');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Engine Config
 */

Engine.config({
    xhrLib: axios,
    debug: true,
    defaultEnvironment: 'ws',
    environments: {
        ws: {
            apiHost: window.env.MILESTONES_API_HOST,
        },
        publicApi: {
            apiHost: window.env.MILESTONES_AUTH_HOST,
        },
    },
});

SelectConfig.set({
    xhrLib: axios,
    apiHost: window.env.MILESTONES_AUTH_HOST,
    apiPrefix: 'public-api',
    apiVersion: 'v1',
});


/**
 * Search Cities
 */
SearchCitiesConfig.set({
    xhrLib: axios,
    apiHost: window.env.MILESTONES_AUTH_HOST,
    apiPrefix: 'public-api',
    apiVersion: 'v1',
});

/**
 * Plugins
 */
Vue.use(BootstrapVue, BootstrapVueConfig);
Vue.use(WsUiKitLibrary);
Vue.use(MilestonesPlugin);
Vue.use(VueHelpers);


Vue.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1,
    lazyComponent: true
});

Vue.use(Loading, {
    color: '#1ACEB3',
});
Vue.component('vue-loading', Loading);

Vue.component('auth', () => import("./components/auth/Auth"));
Vue.component('account-disabled', () => import('./components/auth/Auth'));
Vue.component('forgot-password', () => import("./components/auth/ForgotPassword"));
Vue.component('reset-password', () => import("./components/auth/ResetPassword"));
Vue.component('confirm-password', () => import("./components/auth/ConfirmPassword"));
Vue.component('account-confirm', () => import('./components/auth/AccountConfirm/AccountConfirm'));
Vue.component('verify', () => import('./components/auth/Verify'));
Vue.component('client-gateway', () => import('./components/auth/ClientGateway'));
Vue.component('onboarding', () => import('./components/auth/Onboarding/Onboarding'));

Vue.component('invite-failed', () => import('./components/invite/NotFound/NotFound'));
Vue.component('invite-actions', () => import('./components/invite/InviteActions/InviteActions'));
Vue.component('invite-accepted', () => import('./components/invite/InviteAccepted/InviteAccepted'));
Vue.component('invite-accept', () => import('./components/invite/InviteAccept/InviteAccept'));
Vue.component('invite-opt-out', () => import('./components/invite/InviteOptOut/InviteOptOut'));
Vue.component('pending-hub-invitation', () => import('./layouts/HomeownerHubInvitation/PendingHubInvitation'));

Vue.component('home-ownership-video', () => import('./layouts/HomeownerHubInvitation/HomeOwnershipVideo/HomeOwnershipVideo'));
Vue.component('sso-page-not-found', () => import('./components/ssoredirect/SSOPageNotFound'));
Vue.component('email-subscription', () => import('./components/emailSubscription/EmailSubscription'));
Vue.component('not-found-error', () => import('@milestoneslabs/milestones-ui-kit/src/views/Errors/404/Primary/PrimaryNotFoundError'));
Vue.component('reset-auth-cookie', () => import('./components/auth/ResetAuthCookie'));

Vue.component('oauth-authorize',() => import('./components/auth/OAuth/OAuthAuthorize'));
Vue.component('oauth-authorized-clients', () => import('./components/passport/OauthAuthorizedClients'));
Vue.component('oauth-clients', () => import('./components/passport/OauthClients'));
Vue.component('oauth-personal-access-tokens', () => import('./components/passport/OauthPersonalAccessTokens'));


const app = new Vue({
    el: '#app',
    store,
    ...App
});
